import CameraPhoto from 'jslib-html5-camera-photo';
import FACING_MODES from 'jslib-html5-camera-photo';
import {errorAlert} from "../extensions/Swal";

export class PhotoCapture
{
	/** @type JQueryStatic */
	modal;

	/** @type HTMLVideoElement */
	video;

	/** @type CameraPhoto */
	camera;

	constructor()
	{
		this.createModal();
	}

	createModal()
	{
		let modal = $('<div class="modal fade">');
		let dialog = $('<div class="modal-dialog modal-fullscreen">');
		let header = $('<div class="modal-header">').text('Capture Photo');
		this.video = $('<video autoplay class="bg-dark">').get(0);
		let body = $('<div class="modal-body bg-dark p-0 overflow-hidden">').append(this.video);

		$(document.body).append(modal);

		this.modal = modal.append(
			dialog.append(
				$('<div class="modal-content">')
					.append(header, body)));
	}

	show(autoStart)
	{
		this.modal.modal('show');
		return new Promise((resolve) =>
		{
			setTimeout(() =>
			{
				if (autoStart)
					this.start();
				resolve(this);
			}, 250);
		});
	}

	updateVideoSize()
	{
		let parent = this.video.parentElement;
		this.video.width = parent.clientWidth;
		this.video.height = parent.clientHeight;
	}

	start()
	{
		this.updateVideoSize();
		this.camera = new CameraPhoto(this.video);
		this.camera.startCamera(FACING_MODES.ENVIRONMENT, { width: 960, height: 640 })
		.then((stream) =>
		{
			this.updateVideoSize();
			console.log(stream);
			console.log('Photo capture started.');
		})
		.catch((error) =>
		{
			console.log(error);
			errorAlert('Camera Error', error);
		});
	}
}

window.PhotoCapture = PhotoCapture;
